import React from 'react';
import Joi from 'joi';
import validation from 'react-validation-mixin';
import strategy from 'joi-validation-strategy';
import Button from 'material-ui-next/Button';
import TextField from 'material-ui-next/TextField';
import Dialog, {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from 'material-ui-next/Dialog';

class AliasDialog extends React.Component {
  state = {
    open: false,
    err_msg: '',
    device: null,
    alias: ''
  };

  validatorTypes = {
    alias: Joi.string()
              .required()
              .max(50)
              .label('Device Alias')
  };

  getValidatorData = () => {
    return this.state
  }

  handleClickOpen = (device_data) => {
    this.setState({
      open: true,
      device: device_data,
      alias: device_data.alias || ''
    });
  };

  handleClose = () => {
    this.setState({
      open: false,
    });
  };

  handleChange = (e) => {
    const target = e.target;
    var value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }

  handleSubmit = (e) => {
    var new_alias = this.state.alias
    var device_data = this.state.device

    this.props.onSubmitAlias(
      device_data, new_alias, err => {
        if (err) {
          return this.setState({
            err_msg: err.message
          })
        }
        this.handleClose()
      }
    )
  }

  render() {
    var device_id = ''
    var default_id = ''
    if (this.state.device) {
      device_id = this.state.device.alias
      default_id = this.state.device.id
    }
    return (
      <div>
        <Dialog
          open={this.state.open}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">Set Device Alias</DialogTitle>
          <DialogContent>
            <DialogContentText>
              <div>
                Set alias for "{device_id}".
              </div>
              <div>Notes:</div>
              <div>
                Clear alias to reset to default "{default_id}".
              </div>
              <span>
                {this.state.err_msg}
              </span>
            </DialogContentText>
            <TextField
              autoFocus
              id="alias"
              name="alias"
              type="text"
              onChange={this.handleChange}
              value={this.state.alias}
              fullWidth
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Cancel
            </Button>
            <Button onClick={this.handleSubmit} color="primary">
              Change
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

AliasDialog.defaultProps = {
  onSubmitAlias: null
}

export default validation(strategy)(AliasDialog)



// WEBPACK FOOTER //
// ./src/views/devices/alias_dialog.react.js